import http from './';
import AsyncStorage from "@react-native-async-storage/async-storage";

export const fetchZirmajmoeh = async () => {
    const token = await AsyncStorage.getItem("token");
    try {
        const headers = {
            'x-auth':JSON.parse(token),
            'Content-Type': 'application/json',
          } 

        const { data } = await http.post(`${http.url2}/zirMajmoeh`,null,{
            headers: headers
          });
        return data.Data;
    } catch (err) {
        console.log(err);
    }
};
